import { render, staticRenderFns } from "./fee-invoice.vue?vue&type=template&id=6042e6ec&scoped=true"
import script from "./fee-invoice.vue?vue&type=script&lang=js"
export * from "./fee-invoice.vue?vue&type=script&lang=js"
import style0 from "./fee-invoice.vue?vue&type=style&index=0&id=6042e6ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6042e6ec",
  null
  
)

export default component.exports